<template>
  <div class="slideshow-page">
    <div v-if="slides.length > 0" id="tpCarousel" class="carousel slide" data-bs-ride="carousel" data-bs-interval="5000">
      <div class="carousel-inner">
        <div
          v-for="(item, index) in slides"
          :key="item.id"
          :class="['carousel-item', { active: index === 0 }]"
        >
          <div class="slide-frame">
            <img
              :src="resolveImageUrl(item.url)"
              class="slide-image"
              alt="Time portrait slideshow"
            >
          </div>
        </div>
      </div>
    </div>

    <div v-else class="empty-state">
      {{ $t("noSlideshowImages") }}
    </div>
  </div>
</template>

<script>
import config from '@/config'
import { Carousel } from 'bootstrap'

export default {
  name: 'TimePortraitSlideshow',
  data() {
    return {
      slides: [],
      refreshTimer: null,
      carouselInstance: null,
    }
  },
  mounted() {
    this.fetchSlides().then(() => {
      this.$nextTick(() => {
        const el = document.getElementById('tpCarousel')
        if (el) {
          this.carouselInstance = new Carousel(el, {
            interval: 5000, // 圖片切換間隔時間
            ride: 'carousel',
            pause: false,
            touch: false,
            wrap: true,
          })
        }
      })
    })

    this.refreshTimer = setInterval(() => {
      this.fetchSlides()
    }, 60000) // 輪詢間隔時間
  },
  beforeUnmount() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
      this.refreshTimer = null
    }

    if (this.carouselInstance) {
      this.carouselInstance.dispose()
      this.carouselInstance = null
    }
  },
  methods: {
    async fetchSlides() {
      try {
        const response = await fetch('/stable_diffusion/api/time-portrait/slideshow')

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`)
        }

        const data = await response.json()
        this.slides = Array.isArray(data) ? data : []
      } catch (error) {
        console.error('Failed to fetch slideshow items:', error)
      }
    },

    resolveImageUrl(url) {
      if (url.startsWith('/media/')) {
        if (window.location.origin.includes(config.apiBaseUrl)) {
          return url
        }
        return `${config.apiBaseUrl}${url}`
      }
      return url
    },
  },
}
</script>

<style scoped>
.slideshow-page {
  width: 100vw;
  height: 100vh;
  background: linear-gradient(180deg, #1b1714 0%, #0f0f10 100%);
  overflow: hidden;
}

.carousel,
.carousel-inner,
.carousel-item {
  width: 100%;
  height: 100%;
}

.slide-frame {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  
}

.slide-image {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  box-shadow: 0 12px 40px rgba(0,0,0,0.28);
  border-radius: 8px;
}

.empty-state {
  width: 100%;
  height: 100%;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
}
</style>